import { BackendError, Service } from '@genial/services';
import { ResponsesCurrentAccountItemResponse } from '@genial/services/dist/models';
import { selectorFamily } from 'recoil';

import { advisorIdToApisSelector, partnerIdToApisSelector } from '../../../master/selector';
import { screenName } from '../../constants';
import { statementsFilterParamsState } from '../atom';
import { CurrentAccountStatementsParamsProps } from '../types';

export const currentAccountStatementsQuery = selectorFamily<
  | {
      data: ResponsesCurrentAccountItemResponse;
    }
  | null
  | undefined,
  { accountNumber: number; callEndpoint?: boolean }
>({
  key: 'CustomerDetail/currentAccountStatementsQuery',
  get: ({ accountNumber, callEndpoint }) => {
    return async ({ get }) => {
      const responseEmpty = { data: {} as ResponsesCurrentAccountItemResponse };

      if (!callEndpoint) {
        return responseEmpty;
      }

      try {
        const params = get(statementsFilterParamsState) as CurrentAccountStatementsParamsProps;
        const advisorSelected = get(advisorIdToApisSelector);
        const partnerSelected = get(partnerIdToApisSelector);

        const { data } = await Service.Finance.V1.getStatementByCurrentAccountAccountNumber({
          ...params,
          screenName,
          advisorId: advisorSelected,
          partnerId: partnerSelected,
          accountNumber,
        });

        const response = { data: data?.currentAccount || responseEmpty.data };
        return response;
      } catch (error) {
        const backendError = error as BackendError;

        if (backendError.statusCode === 404) {
          return responseEmpty;
        }

        throw error;
      }
    };
  },
});
